/**
 * 複数の「保存中か」の ref を、どれか 1 つが真なら真として読める 1 つの ref の形にまとめる
 * (SCR-M-001 §6.2「同時に保存するもの」。推薦結果の設定を保存する 3 つのフックが、互いの保存中を
 * 押した時点の値で読むため。Issue #777)。値は読むたびに元の ref から求める (まとめた時点の値を持たない)。
 *
 * @param {...({current: boolean}|null|undefined)} refs
 * @returns {{readonly current: boolean}}
 */
export function anySavingRef(...refs) {
    return {
        get current() {
            return refs.some((ref) => Boolean(ref?.current));
        },
    };
}
